import * as Styles from './BarChart.styles';

export type BarChartProps = {
  width: number;
  label: string;
  value: number;
  hasOpacity: boolean;
};

const BarChart = function ({ label, width, value, hasOpacity }: BarChartProps): JSX.Element {
  return (
    <Styles.Container>
      <Styles.Bar width={width}>
        <Styles.Label hasOpacity={hasOpacity}>{label}</Styles.Label>
        <Styles.Value>{value}</Styles.Value>
      </Styles.Bar>
    </Styles.Container>
  );
};

export default BarChart;
